module.exports = __webpack_public_path__ + "static/media/Frill.31473c4a.png";